import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const PROPERTY_UNITS_ENDPOINTS = {
  V2: createEndpoints('v2', {
    PROPERTY_UNITS: '/admin/property-units/',
    PROPERTY_UNIT_DETAIL: (id: string) => `/admin/property-units/${id}/`,
    PROPERTY_RELATIONS: (viewName: string) => `/property-relations/?view=${viewName}`,
    PROPERTY_UNIT_THUMBNAIL: (clientId: string, unitId: string) => `/clients/${clientId}/units/${unitId}/thumbnail/`,
    PROPERTY_UNIT_FILE_TYPES: '/property-unit-file-types/',
    PROPERTY_UNIT_FILE: (unitId: string, fileId: string) => `/admin/property-units/${unitId}/files/${fileId}/`,
    PROPERTY_UNIT_FILES: (unitId: string) => `/admin/property-units/${unitId}/files/`,
    PROPERTY_UNIT_CUSTOMER_UNITS: (serviceId: string, customerId: string) => `/clients/${customerId}/units/packages/?service=${serviceId}`,
    PROPERTY_CUSTOMER_UNITS: (customerId: string) => `/clients/${customerId}/units/`,
  }),
} as const;
